import { render, staticRenderFns } from "./issue-code.vue?vue&type=template&id=7c4ba63f&"
import script from "./issue-code.vue?vue&type=script&lang=js&"
export * from "./issue-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports